import { useGetCurrentUser } from "@workspace/api-client-react";
import type { Member } from "@workspace/api-client-react";

export interface CurrentMemberResult {
  isAdmin: boolean;
  member: Member | undefined;
  isCaptain: boolean;
  canManageSquad: boolean;
  isLoading: boolean;
  allMembers: Member[];
}

export function useCurrentMember(squadId?: number): CurrentMemberResult {
  const { data, isLoading } = useGetCurrentUser();

  const isAdmin = data?.isAdmin ?? false;
  const allMembers = data?.members ?? [];
  const member = squadId
    ? allMembers.find((m) => m.squadId === squadId)
    : undefined;
  const isCaptain = member?.role === "captain";
  const canManageSquad = isAdmin || isCaptain;

  return { isAdmin, member, isCaptain, canManageSquad, isLoading, allMembers };
}
